import { monthLabel } from '../model/months'
import type { AccountAsOf } from '../model/portfolioOverview'
import { statementsStartText, unreadStatementText } from '../portfolioText'

// What to say where the month's statement figures would be. Empty when there is a statement.
export const gapSentence = (account: AccountAsOf): string => {
  const month = monthLabel(account.month)
  switch (account.status) {
    case 'before_first_statement':
      return statementsStartText(account)
    case 'missing':
      return `No statement for ${month}`
    case 'two_statements':
      return `Two statements for ${month}`
    case 'failed_read':
      return unreadStatementText(account)
    case 'verifying':
      return `The ${month} statement is still being verified`
    case 'mid_cycle':
      return `No statement ends in ${month}`
    case 'ended':
      return 'Its last statement printed a total of $0.00'
    default:
      return ''
  }
}
